import { useState } from 'react';

/**
 * Sync state to local storage so that it persists through
 * a page refresh or when navigated to different apps within the same domain.
 * @param key unique identifier
 * @param initialValue initial value for specified key
 * @returns
 */
export const useLocalStorage = <T>(key: string, initialValue?: T) => {
  const [storedValue, setStoredValue] = useState<T>(() => {
    if (typeof window === 'undefined') {
      return initialValue;
    }
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      return initialValue;
    }
  });

  const setValue = (valueToStore: T) => {
    try {
      setStoredValue(valueToStore);
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch (error) {
      console.log(error);
    }
  };

  return { storedValue, setValue };
};
